import { Plus } from "lucide-react";
import { columns } from "./columns";
import { useNavigate } from "react-router-dom";
import { Heading } from "../../ui/heading";
import { Separator } from "../../ui/separator";
import { Gallerie } from "@/src/data/types";
import { Button } from "../../ui/button";
import { DataTable } from "../../ui/data-table";

interface GallerieProps {
  data: Gallerie[];
}

export const InquiriesData: React.FC<GallerieProps> = ({ data }) => {
  const router = useNavigate();

  return (
    <>
      <div className="flex items-start justify-between">
        <Heading
          title={`Enquêtes publiques (${data.length})`}
          description="Gestion des enquêtes publiques"
        />
        <Button
          className="text-xs md:text-sm"
          onClick={() =>
            router(`/admin-dashboard/mediatheque/enquetes-publiques/ajouter`)
          }
        >
          <Plus className="w-4 h-4 mr-2" /> Ajouter
        </Button>
      </div>
      <Separator />
      <DataTable columns={columns} data={data} />
    </>
  );
};
